/* B1G2 campaign landing — progressive "show more" for each product group.
   Products are rendered by Liquid; this only reveals the next batch. */

if (!customElements.get('b1g2-product-row')) {
  customElements.define(
    'b1g2-product-row',
    class B1g2ProductRow extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-b1g2-load-more]');
        if (!this.button) return;

        this.status = this.querySelector('.b1g2-group__status');
        this.step = parseInt(this.dataset.step, 10) || 6;
        this.baseLabel = this.button.textContent.trim();

        this.button.addEventListener('click', this.reveal.bind(this));
      }

      get hiddenItems() {
        return Array.from(this.querySelectorAll('.b1g2-group__product[hidden]'));
      }

      reveal() {
        const hidden = this.hiddenItems;
        if (!hidden.length) {
          this.button.hidden = true;
          return;
        }

        const batch = hidden.slice(0, this.step);
        batch.forEach((item) => item.removeAttribute('hidden'));

        const remaining = this.hiddenItems.length;

        if (remaining === 0) {
          this.button.hidden = true;
        } else if (remaining < this.step) {
          this.button.textContent = this.baseLabel.replace(/\d+/, remaining);
        }

        if (this.status) {
          const shown = this.querySelectorAll('.b1g2-group__product:not([hidden])').length;
          const total = this.querySelectorAll('.b1g2-group__product').length;
          this.status.textContent = `Showing ${shown} of ${total} products`;
        }

        // Move focus to the first newly revealed card so keyboard users keep their place.
        const focusTarget = batch[0] && batch[0].querySelector('a');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
      }
    }
  );
}
